(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article"]) return;
  try {
    
  class SocialShare extends HTMLElement {
    constructor() {
      super();

      this.copyText = this.querySelector('[data-social-share-copy-text]');
      this.copyButton = this.querySelector('[data-social-share-copy]');
      this.copyButton.addEventListener('click', this.copyContent.bind(this));

      this.debouncedOnLoad = debounce(() => {
        this.socialObserver();
      }, 10);

      // stick on scroll
      window.addEventListener('scroll', this.debouncedOnLoad.bind(this));

      // stick if it's visible on load
      window.addEventListener('load', this.debouncedOnLoad.bind(this));
    }
    socialObserver() {
      // Register IntersectionObserver
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const elementBounds = entry.boundingClientRect;

          if (elementBounds.top < 10) {
            if (!this.classList.contains('is-fixed')) this.classList.add('is-fixed');
          } else {
            if (this.classList.contains('is-fixed')) this.classList.remove('is-fixed');
          }
        });
      });

      observer.observe(this);
    }

    async copyContent(event) {
      const button = event.currentTarget;
      let text = button.dataset.link;
      try {
        await navigator.clipboard.writeText(text);
        this.copyText.classList.add('opacity-100');
        this.copyText.textContent = 'Link gekopieerd!';
        setTimeout(() => {
          this.copyText.classList.remove('opacity-100');
          this.copyText.textContent = '';
        }, 2000);

        dataLayer.push({ event: 'share-copy', url: '{{ article.url }}' });
      } catch (err) {
        console.error('Failed to copy: ', err);
      }
    }
  }
  if (!customElements.get('article-social-share')) {
    customElements.define('article-social-share', SocialShare);
  }

  } catch(e) { console.error(e); }
})();
})();
